// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"68bdc228","200":"b7d38c5a","681":"5fee6d18","699":"79c92679"}[chunkId] + ".chunk.js";
};